<script>
import { computed, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { applyDeviceSpecificStyles } from './utils/deviceDetection';
import { getAndProcessAllParams } from './utils/params';

export default {
  name: 'App',
  setup() {
    const appRoot = ref(null);
    const route = useRoute();
    const routeTransitionName = computed(() => (
      route.meta.disableRouteTransition ? '' : 'fade'
    ));
    const appStyle = computed(() => ({
      background: route.meta.appBackground || ''
    }));

    onMounted(() => {
      // 根据设备类型设置样式
      if (appRoot.value) {
        applyDeviceSpecificStyles(appRoot.value);
      }
      
      // 处理URL参数
      getAndProcessAllParams();
      
      // 设置viewport meta以确保响应式布局在移动设备上正常工作
      const viewport = document.querySelector('meta[name=viewport]');
      if (!viewport) {
        const meta = document.createElement('meta');
        meta.name = 'viewport';
        meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
        document.head.appendChild(meta);
      } else {
        // 确保即使viewport标签已存在也会设置禁止缩放
        viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
      }

    });
    
    return {
      appRoot,
      routeTransitionName,
      appStyle
    };
  }
}
</script>

<template>
  <div id="app" ref="appRoot" :style="appStyle">
    <router-view v-slot="{ Component }">
      <transition :name="routeTransitionName">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<style>
/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

html, body {
  touch-action: manipulation;
  -ms-touch-action: manipulation;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar,
#app::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

#app {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  overflow-x: hidden;
  background: #fff;
}

/* 不同设备特定样式 */
.ios-device {
  /* iOS特定修复 */
  -webkit-overflow-scrolling: touch;
}

.android-device {
  /* Android特定修复 */
}
</style>
